module.exports = __webpack_public_path__ + "img/Mardona-1.9774cff0.webp";